import {LOCATION} from './utils/global';
import setMediaQueryList from './utils/mql';
import setResizeEvent from './utils/resize';
import useDeviceObserver from './utils/useDeviceObserver';

const locationPathArray = LOCATION.path.replace(/^\/|\/$/g, '').split('/');

// 検索ページでは遅延して実行させるため実行しない
if (locationPathArray[0] !== 'search') {
    require('loading-attribute-polyfill/loading-attribute-polyfill');
}

// import widgets
import setSalesTime from './widget/setSalesTime';
import dropdown from './widget/dropdown';
import toggle from './widget/toggle';
import tab from './widget/tab';
import carousel from './widget/carousel';
import modal from './widget/modal';
import readMore from './widget/readMore';
import copyButton from './widget/copyButton';
import followIfBleed from './widget/followIfBleed';
import smoothScroll from './widget/smoothScroll';
import slider from './widget/slider';
import lightbox from './widget/lightbox';
import footerConversionClose from './widget/footerConversionClose';
import removeCurrentProduct from './widget/removeCurrentProduct';
import filter from './widget/filter';
import sort from './widget/sort';
import loadNavContent from './widget/loadNavContent';
import getCountInCart from './widget/getCountInCart';
import saveViewHistory from './widget/saveViewHistory';
import detailedConditionSearch from './widget/detailedConditionSearch';
import favoriteButton from './widget/favoriteButton';
import dataLinkage from './widget/dataLinkage';
import searchContent from './widget/searchContent';
import customBgColor from './widget/customBgColor';
import rankLinkHover from './widget/rankLinkHover';
import changeCartButton from './widget/changeCartButton';
import handleLogin from './widget/handleLogin';
import toggleTabIndexOnScroll from './widget/toggleTabIndexOnScroll';

(() => {
    setMediaQueryList();
    setResizeEvent();
    useDeviceObserver();

    setSalesTime();

    dropdown();

    toggle();

    carousel();

    loadNavContent();

    followIfBleed();

    footerConversionClose(document.querySelector('.l-footer__conversion'));

    modal();

    copyButton();

    removeCurrentProduct();

    sort();

    filter();

    tab();

    readMore();

    smoothScroll();

    lightbox();

    slider();

    detailedConditionSearch();

    getCountInCart();

    saveViewHistory();

    dataLinkage(document.querySelectorAll('.js-data-linkage'));

    searchContent(document.querySelector('.js-search-type2'), document.querySelector('.js-searchConditionList'), document.querySelector('.js-searchConditionInput'));

    favoriteButton();

    customBgColor();

    rankLinkHover();

    changeCartButton();

    handleLogin();

    toggleTabIndexOnScroll();
})();
